const languages = [
    {
        code: 'en',
        text: 'English',
    },
    {
        code: 'de-DE',
        text: 'Deutsch',
    },
    {
        code: 'nl-NL',
        text: 'Dutch',
    },
    {
        code: 'es-ES',
        text: 'Español',
    },
    {
        code: 'fr-FR',
        text: 'Français',
    },
    {
        code: 'pt-PT',
        text: 'Português',
    },
    {
        code: 'it-IT',
        text: 'Italiano',
    },
    {
        code: 'tr-TR',
        text: 'Türkçe',
    },
    {
        code: 'ar-SA',
        text: 'اللغة العربية',
    },
    {
        code: 'bn-BD',
        text: 'বাংলা',
    },
    {
        code: 'ja-JP',
        text: '日本語',
    },
    {
        code: 'ru-RU',
        text: 'Русский',
    },
    {
        code: 'uk-UA',
        text: 'Українська',
    },
    {
        code: 'zh-CN',
        text: '简体中文',
    },
    {
        code: 'zh-HK',
        text: '繁體中文',
    },
    {
        code: 'fa-IR',
        text: 'فارسی',
    },
];
export default languages;
